/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useCallback, useEffect, useState} from 'react'
import {Link, useNavigate} from 'react-router-dom'
import axios from 'axios'
import {KTIcon} from '../../../helpers'
import {AdminUserAvatar} from './AdminUserAvatar'
import {AdminAuth, clearAdminAuth, getAdminMenuProfile} from '../../../../app/modules/auth/core/AdminAuth'
import {apiUrl} from '../../../../api-utils/constantVariables'

const SETTINGS_PATH = '/account/settings'

const HeaderUserMenu: FC = () => {
  const navigate = useNavigate()
  const [, bump] = useState(0)
  useEffect(() => {
    const onChange = () => bump((n) => n + 1)
    window.addEventListener('shrido-admin-profile-changed', onChange)
    window.addEventListener('storage', onChange)
    return () => {
      window.removeEventListener('shrido-admin-profile-changed', onChange)
      window.removeEventListener('storage', onChange)
    }
  }, [])

  const profile = getAdminMenuProfile()

  const logout = useCallback(async () => {
    const token = AdminAuth()
    try {
      if (token) {
        await axios.post(
          `${apiUrl}/admin/auth/logout`,
          {},
          {headers: {'x-access-token': token}},
        )
      }
    } catch {
      /* still clear local session */
    } finally {
      clearAdminAuth()
      navigate('/auth')
    }
  }, [navigate])

  return (
    <div
      className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-semibold py-4 fs-6 w-275px'
      data-kt-menu='true'
    >
      <div className='menu-item px-3 mb-3'>
        <div className='menu-content d-flex align-items-center px-3'>
          <div className='flex-shrink-0 me-3'>
            <AdminUserAvatar sizeClass='symbol-50px' labelClass='fs-5' />
          </div>
          <div className='d-flex flex-column min-w-0 flex-grow-1'>
            <span className='fs-6 fw-bold text-gray-800 text-truncate'>
              {profile?.displayName ?? 'Admin'}
            </span>
            <span className='fw-semibold text-muted text-hover-primary fs-7 text-truncate' title={profile?.email}>
              {profile?.email ?? '—'}
            </span>
          </div>
        </div>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <Link
          to={SETTINGS_PATH}
          className='menu-link px-5'
          title='Profile, password, and security'
        >
          <span className='menu-icon me-2'>
            <KTIcon iconName='setting-2' className='fs-3 text-gray-600' />
          </span>
          <span className='menu-title'>Account settings</span>
        </Link>
      </div>

      <div className='separator my-2'></div>

      <div className='menu-item px-5'>
        <button
          type='button'
          className='menu-link px-5 w-100 text-start btn btn-active-color-primary border-0 bg-transparent text-gray-800'
          onClick={logout}
        >
          <span className='menu-icon me-2'>
            <KTIcon iconName='exit-right-corner' className='fs-3 text-gray-600' />
          </span>
          <span className='menu-title'>Sign out</span>
        </button>
      </div>
    </div>
  )
}

export {HeaderUserMenu}
